import CustomTitle from "../../../components/CustomMiscellaneous/CustomTitle";
import TableView from "../../Common/TableView";
import { FaturacaoClientesTableConfigs } from "./FaturacaoClientes.config";
import { FATURACAO_CLIENTES_EXTENSION, generalObjectBuilder, genericDelete, genericGetWithProcessor, genericPost, genericUpdate, paginatedGetWithProcessor } from "../../../services/api.service";


export default function FaturacaoClientes() {

    return (<div>
        <TableView
            title={"Faturação Clientes"}

            postEntity={genericPost(FATURACAO_CLIENTES_EXTENSION)}
            editEntity={genericUpdate(FATURACAO_CLIENTES_EXTENSION)}
            deleteEntity={genericDelete(FATURACAO_CLIENTES_EXTENSION)}
            addButtonText={"Nova Fatura"}
            tableConfigs={FaturacaoClientesTableConfigs}
            entityName={"Fatura de Cliente"}
            dataBuildFunction={generalObjectBuilder(FaturacaoClientesTableConfigs)}
            idProp={"code"}
            reroute={true}
            configMapKey={'faturacao-clientes'}
        />
    </div>)

}

